import { useEffect, useRef, useState } from "react";
import { SlidersHorizontal, Check } from "lucide-react";

export default function ManageColumns({ columns, isOn, toggle, reset, testid = "manage-columns" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid={`${testid}-btn`} onClick={() => setOpen((o) => !o)} className="h-11 px-4 rounded-xl border border-zinc-200 bg-white font-semibold text-sm flex items-center gap-2 active:scale-95"><SlidersHorizontal size={16} />Columns</button>
      {open && (
        <div data-testid={`${testid}-menu`} className="absolute right-0 mt-2 w-56 bg-white border border-zinc-200 rounded-xl shadow-xl z-50 py-2">
          <div className="px-3 pb-2 mb-1 border-b border-zinc-100 flex items-center justify-between"><span className="text-xs font-bold uppercase tracking-wider text-zinc-400">Manage columns</span><button type="button" onClick={reset} data-testid={`${testid}-reset`} className="text-xs text-brand font-semibold">Reset</button></div>
          <div className="max-h-72 overflow-y-auto">
            {columns.map((c) => (
              <button key={c.key} type="button" data-testid={`${testid}-opt-${c.key}`} onClick={() => toggle(c.key)} className="w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-zinc-50">
                <span>{c.label}</span>
                <span className={`h-4 w-4 rounded border flex items-center justify-center ${isOn(c.key) ? "bg-brand border-brand text-white" : "border-zinc-300"}`}>{isOn(c.key) && <Check size={12} />}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
